import { render, staticRenderFns } from "./ProductOverviewSort.vue?vue&type=template&id=310067c0&scoped=true"
import script from "./ProductOverviewSort.vue?vue&type=script&lang=js"
export * from "./ProductOverviewSort.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "310067c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('310067c0')) {
      api.createRecord('310067c0', component.options)
    } else {
      api.reload('310067c0', component.options)
    }
    module.hot.accept("./ProductOverviewSort.vue?vue&type=template&id=310067c0&scoped=true", function () {
      api.rerender('310067c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/js/Components/ProductOverviewSort.vue"
export default component.exports